import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationBellComponent } from '../notification-bell/notification-bell.component';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-top-bar',
    standalone: true,
    imports: [CommonModule, NotificationBellComponent],
    templateUrl: './top-bar.component.html',
    styleUrl: './top-bar.component.scss'
})
export class TopBarComponent {
    private readonly authService = inject(AuthService);

    get userName(): string {
        const user = this.authService.getCurrentUser();
        return user?.nombre || 'Usuario';
    }

    get userInitials(): string {
        const user = this.authService.getCurrentUser();
        if (!user?.nombre) return 'U';
        const names = user.nombre.split(' ');
        return names.length > 1
            ? `${names[0][0]}${names[1][0]}`
            : names[0][0];
    }
}
